import usePureState from '@/hooks/usePureState';
import calendarService from '@/services/calendar/calendar.service';
import { DateTime } from 'luxon';
import { assignEventsToDays } from './tcalendar.service';

export interface ICalendarEvent {
	title: string;
	id: string;
	start: DateTime;
	end: DateTime;
	color: string;
	row?: number;
	/**
	 * Public UI field.
	 * When true the hour is hidden. This is useful for all day events.
	 */
	uiHideHour?: boolean;
}
interface IProps {
	onEventClick?: (event: ICalendarEvent) => void;
	onRangeSelected?: (args: { start: DateTime; end: DateTime }) => void;
	events: Array<ICalendarEvent>;
	locale?: string;
	timeZone: string;
	month: number;
	weekStartsOnMonday?: boolean;
	year: number;
	isLoading?: boolean;
}

export function useCalendar(props: IProps) {
	const locale = props.locale || navigator.language;
	const dayTemplates = calendarService.generateMonthDays({ ...props, timeZone: props.timeZone, locale });

	const { state, dispatch } = usePureState({
		isSelecting: false,
		selectionStart: null as DateTime | null,
		selectionEnd: null as DateTime | null,
	});

	function handleEventClick(event: ICalendarEvent) {
		props.onEventClick?.(event);
	}

	const days = assignEventsToDays(dayTemplates, props.events);



	return {
		days,
		state,
		dispatch,
		handleEventClick,
	};
}
